import { render, staticRenderFns } from "./DefaultPageLanguage.vue?vue&type=template&id=248134d7&scoped=true&"
import script from "./DefaultPageLanguage.vue?vue&type=script&lang=js&"
export * from "./DefaultPageLanguage.vue?vue&type=script&lang=js&"
import style0 from "./DefaultPageLanguage.vue?vue&type=style&index=0&id=248134d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248134d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VImg,VRadio,VRadioGroup})
